import { Observable, Subscriber } from 'rxjs';

/**
 * An Observable<void> to be returned instead of creating new observables every time.
 *
 * @see https://github.com/ReactiveX/rxjs/blob/6.5.4/src/internal/observable/empty.ts
 * @see https://github.com/ReactiveX/rxjs/blob/6.5.4/src/internal/observable/never.ts
 */
export const VOID: Observable<void> = new Observable<void>((subscriber: Subscriber<void>): void => {
  subscriber.next();
  subscriber.complete();
});
